// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__5L8qb","gfeWrapper":"CalendarEvent_gfeWrapper__2Wqkb"};